import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";
import { AppShell } from "./components/AppShell";
import { ToastProvider } from "./components/Toast";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AssignedPage } from "./pages/AssignedPage";
import { AdminPage } from "./pages/AdminPage";
import { LoginsPage } from "./pages/LoginsPage";
import { AuthNonTokenPage } from "./pages/AuthNonTokenPage";
import { TransactionsPage } from "./pages/TransactionsPage";
import { StockPage } from "./pages/StockPage";
import { NonStashPage } from "./pages/NonStashPage";
import { HiddenPage } from "./pages/HiddenPage";
import { SettingsPage } from "./pages/SettingsPage";
import { EmployeePage } from "./pages/EmployeePage";
import { MediumPage } from "./pages/MediumPage";
import { EnrichmentFailPage } from "./pages/EnrichmentFailPage";
import { refreshDesktopSettingsCache, isElectronDesktop } from "./desktop";
import "./styles.css";

if (isElectronDesktop()) {
  void refreshDesktopSettingsCache();
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ToastProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<RequireAuth />}>
              <Route element={<AppShell />}>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/enrichment-fail" element={<EnrichmentFailPage />} />
                <Route path="/logins" element={<LoginsPage />} />
                <Route path="/auth-non-token" element={<AuthNonTokenPage />} />
                <Route path="/transactions" element={<TransactionsPage />} />
                <Route path="/stock" element={<StockPage />} />
                <Route path="/non-stash" element={<NonStashPage />} />
                <Route path="/employee" element={<EmployeePage />} />
                <Route path="/medium" element={<MediumPage />} />
                <Route path="/assigned" element={<AssignedPage />} />
                <Route path="/hidden" element={<HiddenPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ToastProvider>
  </StrictMode>
);
